import { ImageComponent, toPlaceholderImage } from '@frontend/internal-assets';
import type { ImageAssetProps } from '@frontend/internal-assets';
import optimizedImage from './image-assets/call-intel-no-transcription.webp';

const thumbHashString = 'eygGDwT4h4aHd2mPY4mHd4ZpeJAHB3kA';
const placeholderImage = toPlaceholderImage(thumbHashString);

const calculatedAspectRatio = 1;
const originalWidth = 400;

const CallIntelNoTranscription = ({
  aspectRatio = calculatedAspectRatio,
  width = originalWidth,
  ...rest
}: ImageAssetProps) => (
  <ImageComponent
    aspectRatio={aspectRatio}
    width={width}
    src={optimizedImage}
    placeholderSrc={placeholderImage}
    {...rest}
  />
);

export default CallIntelNoTranscription;
